import { useMemo } from 'react';

import { canViewerAccessLeaderInsights } from './leaderInsightsAccess';
import { useViewerProfile } from './useViewerProfile';
import { useAuth } from '@workos-inc/authkit-react';

import { VIEWER_OWN_METADATA_SCOPES_QUERY_ARG } from '@/constants/metadata';
import { useGetMetadataScopesQuery } from '@/store/api/metadata';

export const useViewerLeaderInsightsAccess = () => {
  const { user } = useAuth();
  const { role, isRoleLoading } = useViewerProfile();
  const { data: viewerScopes, isLoading: isViewerScopesLoading } = useGetMetadataScopesQuery(
    VIEWER_OWN_METADATA_SCOPES_QUERY_ARG,
    { skip: !user }
  );

  const isLeaderInsightsAccessResolved = Boolean(user) && !isRoleLoading && !isViewerScopesLoading;

  const canAccessLeaderInsights = useMemo(() => {
    if (!isLeaderInsightsAccessResolved) {
      return false;
    }

    return canViewerAccessLeaderInsights(role, viewerScopes?.managesLeaders);
  }, [isLeaderInsightsAccessResolved, role, viewerScopes?.managesLeaders]);

  return {
    managesLeaders: viewerScopes?.managesLeaders,
    canAccessLeaderInsights,
    canUseLeaderFilter: canAccessLeaderInsights,
    isLeaderInsightsAccessResolved,
  };
};
